import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { ApplyTagsEventPublisher } from './apply-tags.usecase';

export class ApplyTagsPublisher implements ApplyTagsEventPublisher {
  private logger = new Logger();

  async publish(callId: string, tagIds: number[]): Promise<void> {
    const busIframe = await BusIframe.getIframe();

    this.logger.info('Publisher: SetTags + Reset', {
      action: 'DIALER.SET_TAGS',
      callId,
      count: tagIds.length,
    });

    // Send DIALER.SET_TAGS then DIALER.RESET back-to-back without any await
    // between them so both messages are queued in the iframe's message queue
    // before either is processed — matching CTI 2.0's synchronous sequence.
    // SET_TAGS transitions the dialer mandatoryTagging → ended;
    // RESET then transitions ended → idle.
    BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: { type: 'DIALER.SET_TAGS', payload: { tagIds } },
    });
    BusEventsPromisifier.promisifyFireAndForgetEvent({
      target: busIframe,
      event: { type: 'DIALER.RESET', payload: {} },
    });
  }
}
